import Vue from "vue";
import Router from "vue-router";
import MainPage from "./views/mainPage/MainPage.vue";

//Общие компоненты
import Pages from "./views/pages/Pages.vue";

import AboutUs from "./views/pages/aboutUs/AboutUs.vue";
import Contacts from "./views/pages/contacts/Contacts.vue";

import CampsPage from "./views/pages/campsPage/CampsPage.vue";
import Camps from "./views/pages/campsPage/camps/Camps.vue";
import CurrentCamp from "./views/pages/campsPage/currentCamp/CurrentCamp.vue";

import ShiftsPage from "./views/pages/shiftsPage/ShiftsPage.vue";
import Shifts from "./views/pages/shiftsPage/shifts/Shifts.vue";
import CurrentShift from "./views/pages/shiftsPage/currentShift/CurrentShift.vue";
import ShiftRequest from "./views/pages/shiftsPage/shiftRequest/ShiftRequest.vue";

//Профиль юзера
import ProfilePage from "./views/pages/profile/ProfilePage.vue";
import Profile from "./views/pages/profile/views/Profile.vue";
import MyChilds from "./views/pages/profile/views/MyChilds.vue";
import Requests from "./views/pages/profile/views/Requests.vue";
import Settings from "./views/pages/profile/views/Settings.vue";

//Админ
import AdminPage from "./views/pages/_admin/AdminPage.vue";
import AdminCampsRegistry from "./views/pages/_admin/views/camps/AdminCampsRegistry";
import AdminCampEditor from "./views/pages/_admin/views/camps/AdminCampEditor";
import AdminAccountsRegistry from "./views/pages/_admin/views/accounts/AdminAccountsRegistry";
import AdminAccountEditor from "./views/pages/_admin/views/accounts/AdminAccountEditor";

//Директор
import ManagerPage from "./views/pages/_manager/ManagerPage";
import ManagerCampsRegistry from "./views/pages/_manager/views/camps/ManagerCampsRegistry";
import ManagerCampEditor from "./views/pages/_manager/views/camps/ManagerCampEditor";
import ManagerCampEditorAbout from "./views/pages/_manager/views/camps/ManagerCampEditorAbout";
import ManagerCampEditorPlacement from "./views/pages/_manager/views/camps/ManagerCampEditorPlacement";
import ManagerCampEditorDocs from "./views/pages/_manager/views/camps/ManagerCampEditorDocs";
import ManagerCampEditorThings from "./views/pages/_manager/views/camps/ManagerCampEditorThings";
import ManagerCampEditorContacts from "./views/pages/_manager/views/camps/ManagerCampEditorContacts";

import ManagerShiftsRegistry from "./views/pages/_manager/views/shifts/ManagerShiftsRegistry";
import ManagerShiftEditor from "./views/pages/_manager/views/shifts/ManagerShiftEditor";
import ManagerShiftEditorGeneral from "./views/pages/_manager/views/shifts/ManagerShiftEditorGeneral";
import ManagerShiftEditorProgram from "./views/pages/_manager/views/shifts/ManagerShiftEditorProgram";
import ManagerShiftEditorSchedule from "./views/pages/_manager/views/shifts/ManagerShiftEditorSchedule";
import ManagerShiftEditorTeachers from "./views/pages/_manager/views/shifts/ManagerShiftEditorTeachers";
import ManagerShiftEditorContacts from "./views/pages/_manager/views/shifts/ManagerShiftEditorContacts";
import ManagerQuotasRegistry from "./views/pages/_manager/views/shifts/ManagerQuotasRegistry";
import ManagerQuotaEditor from "./views/pages/_manager/views/shifts/ManagerQuotaEditor";

import ManagerRequests from "./views/pages/_manager/views/requests/ManagerRequests";
import ManagerCurrentRequest from "./views/pages/_manager/views/requests/ManagerCurrentRequest";
import ManagerCreateRequest from "./views/pages/_manager/views/requests/ManagerCreateRequest";

import ManagerContract from "./views/pages/_manager/views/contract/ManagerContract";
import ManagerSettings from "./views/pages/_manager/views/settings/ManagerSettings";

//Шаблоны верстки
import Templates from "./views/pages/Pages.vue";

import OperatorPage from "./views/templates/operator/OperatorPage.vue";
import OperatorShifts from "./views/templates/operator/views/OperatorShifts.vue";
import OperatorRequests from "./views/templates/operator/views/OperatorRequests.vue";
import OperatorCurrentRequest from "./views/templates/operator/views/OperatorCurrentRequest.vue";
import OperatorCamp from "./views/templates/operator/views/OperatorCamp/OperatorCamp.vue";
import OperatorCampBasic from "./views/templates/operator/views/OperatorCamp/views/OperatorCampBasic.vue";
import OperatorCampAbout from "./views/templates/operator/views/OperatorCamp/views/OperatorCampAbout.vue";
import OperatorCampPlacement from "./views/templates/operator/views/OperatorCamp/views/OperatorCampPlacement.vue";
import OperatorCampDocs from "./views/templates/operator/views/OperatorCamp/views/OperatorCampDocs.vue";
import OperatorCampThings from "./views/templates/operator/views/OperatorCamp/views/OperatorCampThings.vue";
import OperatorCampContacts from "./views/templates/operator/views/OperatorCamp/views/OperatorCampContacts.vue";

import DirectorPage from "./views/templates/director/DirectorPage.vue";
import DirectorShiftsPage from "./views/templates/director/views/DirectorShifts.vue";
import DirectorShifts from "./views/templates/director/views/DirectorShifts.vue";
import DirectorShiftsCreate from "./views/templates/director/views/DirectorShiftsCreate.vue";
import DirectorShiftsQuota from "./views/templates/director/views/DirectorShiftsQuota.vue";
import DirectorQuotaCreate from "./views/templates/director/views/DirectorQuotaCreate.vue";
import DirectorShiftsDescription from "./views/templates/director/views/DirectorShiftsDescription.vue";
import DirectorShiftsProgram from "./views/templates/director/views/DirectorShiftsProgram.vue";
import DirectorShiftsSchedule from "./views/templates/director/views/DirectorShiftsSchedule.vue";
import DirectorShiftsTeachers from "./views/templates/director/views/DirectorShiftsTeachers.vue";
import DirectorShiftsContacts from "./views/templates/director/views/DirectorShiftsContacts.vue";
import AnalyticsPage from "./views/templates/analytics/AnalyticsPage.vue";
import AnalyticsCharts from "./views/templates/analytics/views/AnalyticsCharts.vue";
import AnalyticsReports from "./views/templates/analytics/views/AnalyticsReports.vue";

import store from "./store";
import {RoleEnums} from "./const";

Vue.use(Router);

const checkPermissions = (to, from, next) => {
  if (store.state.isAuthorized) {
    let role = null;
    to.matched.find(record => {
      if (record.meta.role) {
        role = record.meta.role;
      }
    });
    if (store.state.userData.role === role) {
      next();
      return;
    }
    next("/");
    return;
  }
  next({name: "MainPage", query: {open_modal: "sign_in"}});
};

const _routes = [
  {
    path: "/",
    name: "MainPage",
    component: MainPage
  },
  {
    path: "/pages",
    name: "Pages",
    component: Pages,
    children: [
      {
        path: "camps",
        // name: "CampsPage",
        component: CampsPage,
        children: [
          {
            path: "",
            name: "Camps",
            component: Camps
          },
          {
            path: ":campId",
            name: "CurrentCamp",
            component: CurrentCamp
          }
        ]
      },
      // {
      //   path: "shifts",
      //   component: ShiftsPage,
      //   children: [
      //     {
      //       path: "",
      //       name: "Shifts",
      //       component: Shifts
      //     },
      //     {
      //       path: ":shiftId",
      //       name: "CurrentShifts",
      //       component: CurrentShift
      //     },
      //     {
      //       path: ":shiftId/request",
      //       name: "ShiftRequest",
      //       component: ShiftRequest
      //     }
      //   ]
      // },

      {
        path: "about-us",
        name: "AboutUs",
        component: AboutUs
      },
      {
        path: "contacts",
        name: "Contacts",
        component: Contacts
      },

      {
        path: "profile",
        component: ProfilePage,
        beforeEnter: checkPermissions,
        meta: {role: RoleEnums.PARENT},
        children: [
          {
            path: "",
            name: "Profile",
            component: Profile
          },
          {
            path: "my-childs",
            name: "MyChilds",
            component: MyChilds
          },
          {
            path: "requests",
            name: "Requests",
            component: Requests
          },
          {
            path: "settings",
            name: "Settings",
            component: Settings
          }
        ]
      },
      {
        path: "admin",
        name: "Admin",
        component: AdminPage,
        beforeEnter: checkPermissions,
        meta: {role: RoleEnums.ADMIN},
        redirect: {
          name: "AdminCampsRegistry"
        },
        children: [
          {
            path: "camps",
            name: "AdminCamps",
            redirect: {
              name: "AdminCampsRegistry"
            }
          },
          {
            path: "camps/registry",
            name: "AdminCampsRegistry",
            component: AdminCampsRegistry
          },
          {
            path: "camps/:id",
            name: "AdminCampEditor",
            component: AdminCampEditor
          },
          {
            path: "accounts",
            name: "AdminAccounts",
            redirect: {
              name: "AdminAccountsRegistry"
            }
          },
          {
            path: "accounts/registry",
            name: "AdminAccountsRegistry",
            component: AdminAccountsRegistry
          },
          {
            path: "accounts/staff-campgroup/:id",
            name: "AdminAccountsCreateStaffCampgroup",
            component: AdminAccountEditor
          },
          {
            path: "accounts/staff-camp/:id",
            name: "AdminAccountsCreateStaffCamp",
            component: AdminAccountEditor
          }
        ]
      },
      {
        path: "manager",
        name: "Manager",
        component: ManagerPage,
        beforeEnter: checkPermissions,
        meta: {role: RoleEnums.DIRECTOR},
        redirect: {
          name: "ManagerCamps"
        },
        children: [
          {
            path: "camps",
            name: "ManagerCamps",
            redirect: {
              name: "ManagerCampsRegistry"
            }
          },
          {
            path: "camps/registry",
            name: "ManagerCampsRegistry",
            component: ManagerCampsRegistry
          },
          {
            path: "camps/:id",
            name: "ManagerCampEditor",
            component: ManagerCampEditor,
            redirect: {
              name: "ManagerCampEditorAbout"
            },
            children: [
              {
                path: "about",
                name: "ManagerCampEditorAbout",
                component: ManagerCampEditorAbout
              },
              {
                path: "placement",
                name: "ManagerCampEditorPlacement",
                component: ManagerCampEditorPlacement
              },
              {
                path: "docs",
                name: "ManagerCampEditorDocs",
                component: ManagerCampEditorDocs
              },
              {
                path: "things",
                name: "ManagerCampEditorThings",
                component: ManagerCampEditorThings
              },
              {
                path: "contacts",
                name: "ManagerCampEditorContacts",
                component: ManagerCampEditorContacts
              }

            ]
          },
          {
            path: "shifts",
            name: "ManagerShifts",
            redirect: {
              name: "ManagerShiftsRegistry"
            }
          },
          {
            path: "shifts/registry",
            name: "ManagerShiftsRegistry",
            component: ManagerShiftsRegistry
          },
          {
            path: "shifts/:id",
            name: "ManagerShiftEditor",
            component: ManagerShiftEditor,
            redirect: {
              name: "ManagerShiftEditorGeneral"
            },
            children: [
              {
                path: "general",
                name: "ManagerShiftEditorGeneral",
                component: ManagerShiftEditorGeneral
              },
              {
                path: "quotas",
                name: "ManagerShiftEditorQuotas",
                redirect: {
                  name: "ManagerQuotasRegistry"
                }
              },
              {
                path: "quotas/registry",
                name: "ManagerQuotasRegistry",
                component: ManagerQuotasRegistry
              },
              {
                path: "quotas/:idQuota",
                name: "ManagerQuotaEditor",
                component: ManagerQuotaEditor
              },

              {
                path: "program",
                name: "ManagerShiftEditorProgram",
                component: ManagerShiftEditorProgram
              },
              {
                path: "schedule",
                name: "ManagerShiftEditorSchedule",
                component: ManagerShiftEditorSchedule
              },
              {
                path: "teachers",
                name: "ManagerShiftEditorTeachers",
                component: ManagerShiftEditorTeachers
              },
              {
                path: "contacts",
                name: "ManagerShiftEditorContacts",
                component: ManagerShiftEditorContacts
              }

            ]
          },
          {
            path: "requests",
            name: "ManagerRequests",
            component: ManagerRequests
          },
          {
            path: "requests/create",
            name: "ManagerCreateRequest",
            component: ManagerCreateRequest
          },
          {
            path: "requests/:requestId",
            name: "ManagerCurrentRequest",
            component: ManagerCurrentRequest
          },

          {
            path: "contract",
            name: "ManagerContract",
            component: ManagerContract
          },
          {
            path: "settings",
            name: "ManagerSettings",
            component: ManagerSettings
          }
        ]
      }
    ]
  }
];

const _templates = {
  path: "/templates",
  name: "Templates",
  component: Templates,
  children: [
    {
      path: "operator",
      component: OperatorPage,
      children: [
        {
          path: "shifts",
          name: "OperatorShifts",
          component: OperatorShifts
        },
        {
          path: "",
          name: "OperatorRequests",
          component: OperatorRequests
        },
        {
          path: "requests/:requestId",
          name: "OperatorCurrentRequest",
          component: OperatorCurrentRequest
        },
        {
          path: "camp",
          redirect: "camp/basic",
          name: "OperatorCamp",
          component: OperatorCamp,
          children: [
            {
              path: "basic",
              name: "OperatorCampBasic",
              component: OperatorCampBasic
            },
            {
              path: "about",
              name: "OperatorCampAbout",
              component: OperatorCampAbout
            },
            {
              path: "placement",
              name: "OperatorCampPlacement",
              component: OperatorCampPlacement
            },
            {
              path: "documents",
              name: "OperatorCampDocs",
              component: OperatorCampDocs
            },
            {
              path: "things",
              name: "OperatorCampThings",
              component: OperatorCampThings
            },
            {
              path: "contacts",
              name: "OperatorCampContacts",
              component: OperatorCampContacts
            }
          ]
        }
      ]
    },
    {
      path: "director",
      redirect: "director/shifts",
      component: DirectorPage,
      children: [
        {
          path: "shifts",
          name: "Shifts",
          component: DirectorShifts
        },
        {
          path: "shift/create",
          name: "DirectorShiftsCreate",
          component: DirectorShiftsCreate
        },
        {
          path: "shift/quota",
          name: "DirectorShiftsQuota",
          component: DirectorShiftsQuota
        },
        {
          path: "shift/quota/create",
          name: "DirectorQuotaCreate",
          component: DirectorQuotaCreate
        },
        {
          path: "shift/about",
          name: "DirectorShiftsDescription",
          component: DirectorShiftsDescription
        },
        {
          path: "shift/program",
          name: "DirectorShiftsProgram",
          component: DirectorShiftsProgram
        },
        {
          path: "shift/schedule",
          name: "DirectorShiftsSchedule",
          component: DirectorShiftsSchedule
        },
        {
          path: "shift/teachers",
          name: "DirectorShiftsTeachers",
          component: DirectorShiftsTeachers
        },
        {
          path: "shift/contacts",
          name: "DirectorShiftsContacts",
          component: DirectorShiftsContacts
        }
      ]
    },
    {
      path: "analytics",
      component: AnalyticsPage,
      redirect: "analytics/charts",
      children: [
        {
          path: "charts",
          name: "Charts",
          component: AnalyticsCharts
        },
        {
          path: "reports",
          name: "Reports",
          component: AnalyticsReports
        }
      ]
    }
  ]
};
// _routes.push(_templates);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: _routes
});
